"use client";

import { useState, useEffect } from "react";
import { useParams, useRouter } from "next/navigation";
import TopHeader from "../Components/Block_Components/topHeader/topHeaderBlock";
import NavBlock from "../Components/Block_Components/navBlock/navBlock";
import { parse } from "node-html-parser";
import { getBaseUrl } from "@/lib/getBaseURL";
import { useLanguage } from "../LanguageContext";
import { sanitizeIframeAllowAttributes } from "@/utils/sanitizeIframeAllow";
const PostPage = () => {
  const {language} = useLanguage()
  const params = useParams();
  const router = useRouter();

  // `slug` is an array in `[[...slug]]` so join it into a path
  const slug = params?.slug ? `/${(params.slug as string[]).join("/")}` : "/";

  const [content, setContent] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPost = async () => {
      if (!slug) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const res = await fetch(
          `${getBaseUrl()}/api/pages?filters[url][$eq]=${slug}&locale=${language}`,
          {
            headers: {
              Accept: "application/json",
            },
          }
        );

        if (!res.ok) {
          if (res.status === 404) {
            router.push("/404"); // Redirect if page not found
            return;
          }
          throw new Error(`Failed to fetch post (Status: ${res.status})`);
        }

        const data = await res.json();

        if (data?.data?.length > 0 && data.data[0]?.content) {
          const parsedContent = parse(data.data[0].content);
          setContent(parsedContent.toString());
        } else {
          router.push("/404"); // Redirect if content is missing
          return;
        }
      } catch (err) {
        console.error("Error fetching post:", err);
        setError("Failed to load content.");
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug, router]);

  if (loading) return <div>Loading content...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      <div
        dangerouslySetInnerHTML={{ __html: sanitizeIframeAllowAttributes(content || '') }}
        className="prose max-w-3xl mx-auto p-6"
      />
    </div>
  );
};

export default PostPage;
